export default "__VITE_ASSET__4FcnJj51__"